// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3hAUn","notes":"Notes_notes__2ftAO","note":"Notes_note__35Epc","markdown":"Notes_markdown__33vXn"};